import posthog from "./posthog"

export class EventTrackerService {
  initialize() {
    this.#setupIRSLinkListener();
    this.#setSearchEvent();
  }

  trackEvent(eventName, eventProperties = {}, element) {
    if (!eventName) {
      console.error('Event name is required');
      return;
    }

    const userDevice = document.getElementById("device-properties")?.dataset["properties"];
    const userDeviceProperties = this.#parseJSONProperties(userDevice);

    if (this.#isBot(userDeviceProperties)) {
      return;
    }

    let jsonProperties = typeof eventProperties === 'string'
      ? this.#parseJSONProperties(eventProperties) || {}
      : eventProperties;

    // Handle new tag element if it exists
    if (element) {
      const newTagElement = element.querySelector(".c-card-activity__tag");
      if (newTagElement) {
        newTagElement.style.display = "none";
      }
    }

    const event = {
      event_name: eventName,
      event_time: new Date(),
      event_properties: jsonProperties,
      url: window.location.href,
      page_name: document.title,
      user_agent: navigator.userAgent,
      session_id: this.#posthogSessionId()
    };

    return fetch('/posthog/events', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ event }),
      keepalive: true
    }).catch(error => {
      console.error('Failed to send event:', error);
    });
  }

  // Ties server-captured events to the native PostHog session so session-based
  // insights (duration, events per session) include them.
  #posthogSessionId() {
    if (!window.posthogInitialized) return null;

    try {
      return posthog.get_session_id() || null;
    } catch {
      return null;
    }
  }

  #parseJSONProperties(data){
    try {
      return JSON.parse(data);
    } catch(error){
      console.error("Error parsing JSON:", error);
      return null;
    }
  }

  #setupIRSLinkListener() {
    document.querySelectorAll("a").forEach(link => {
      link.addEventListener("click", (e) => {
        const irsUrl = "https://www.irs.gov/filing/free-file-do-your-federal-taxes-for-free";
        if (e.target.href === irsUrl || e.currentTarget.href === irsUrl) {
          e.stopPropagation();

          const eventProperties = {
            'url': document.location.href,
            'page_name': document.title
          };

          this.trackEvent('Navigation - Clicked Tax Time Link', eventProperties, e.target);
        }
      });
    });
  }

  #isBot(userDeviceProperties) {
    const botIndicators = [
      userDeviceProperties?.saverlife_user_agent?.includes("Amazon-Route53-Health-Check-Service"),
    ];

    return botIndicators.some(indicator => indicator === true);
  }

  #setSearchEvent() {
    $("#search-blog-posts-input").on('keyup', (e) => {
      if (e.keyCode === 13) {
        const eventProperties = {
          'search_text':$(this)[0].value,
          'url':document.location.href,
          'page_name':document.title
        };

        this.trackEvent('Blog - Submitted Search', eventProperties, e.target);
        e.target.clicked_search = false;
      }
    });
  }
}